import { Badge, Box, Fab } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MessageCircleIcon from 'assets/externalIcons/chatRounded';
import { dispatch, useSelector } from 'store';
import { getUserTicketDataAcrossSection, toggleTicketAssignmentSection } from 'store/slices/userAssignmentTicketSectionSlice';
import TickerSection from './TickerSection';
import { useContext, useEffect, useMemo } from 'react';
import { getTicketCount } from './utils';
import CustomContext from 'contexts/CustomCognitoContext';

const UserTicketFloatingButton = () => {
    const data = useSelector((state) => state.userTicketSectionReducer);
    const autContext = useContext(CustomContext);

    const { isTicketSectionOpen } = data;

    const totalCount = useMemo(() => getTicketCount(data), [data]);

    const acmProfile = useSelector((state) => state.acmDashboard.data.acmProfile);
    const { abId = null } = acmProfile || {};

    // Owns page-1 for all tabs — InfiniteScroll uses initialLoad={false}
    useEffect(() => {
        if (!abId) return;
        if (!autContext.isLoggedIn) return;
        dispatch(getUserTicketDataAcrossSection(abId));
    }, [abId, autContext.isLoggedIn]);

    if (!autContext.isLoggedIn) {
        return null;
    }

    return (
        <Box
            sx={{
                position: 'relative',
                marginRight: '40px',
                pointerEvents: 'auto'
            }}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            {isTicketSectionOpen && <TickerSection />}
            <Fab
                onClick={() => dispatch(toggleTicketAssignmentSection())}
                color="secondary"
                aria-label={isTicketSectionOpen ? 'close my tickets' : 'open my tickets'}
            >
                <Badge badgeContent={totalCount} color="error">
                    {!isTicketSectionOpen ? <MessageCircleIcon /> : <CloseIcon />}
                </Badge>
            </Fab>
        </Box>
    );
};

export default UserTicketFloatingButton;
